export const CMSLocationFromJSON = (json: ICMSLocation): ICMSLocationModel => {
	const fromJSON = (json: ICMSLocation) => {
		const {
			place_id,
			main_cms_location_id,
			geo_point,
			is_active_pl,
			is_active_en,
			is_active_de,
			is_active_es,
			is_active_fr,
			is_active_sk,
			is_active_cs,
			custom_menu_item,
			show_on_locations,
			show_in_menu,
			show_in_footer,
			other_location,
			delivery_bus,
			passenger_bus,
			phone_number,
			name_pl,
			name_en,
			name_de,
			name_es,
			name_fr,
			name_sk,
			name_cs,
			subtitle_pl,
			subtitle_en,
			subtitle_de,
			subtitle_es,
			subtitle_fr,
			subtitle_sk,
			subtitle_cs,
			address_pl,
			address_en,
			address_de,
			address_es,
			address_fr,
			address_sk,
			address_cs,
			url_pl,
			url_en,
			url_de,
			url_es,
			url_fr,
			url_sk,
			url_cs,
			created_at,
			updated_at,
			...rest
		} = json

		return {
			...rest,
			placeId: place_id,
			mainCmsLocationId: main_cms_location_id,
			geoPoint: geo_point,
			isActivePL: is_active_pl,
			isActiveEN: is_active_en,
			isActiveDE: is_active_de,
			isActiveES: is_active_es,
			isActiveFR: is_active_fr,
			isActiveSK: is_active_sk,
			isActiveCS: is_active_cs,
			customMenuItem: custom_menu_item,
			showOnLocations: show_on_locations,
			showInMenu: show_in_menu,
			showInFooter: show_in_footer,
			otherLocation: other_location,
			deliveryBus: delivery_bus,
			passengerBus: passenger_bus,
			phoneNumber: phone_number,
			namePL: name_pl,
			nameEN: name_en,
			nameDE: name_de,
			nameES: name_es,
			nameFR: name_fr,
			nameSK: name_sk,
			nameCS: name_cs,
			subtitlePL: subtitle_pl,
			subtitleEN: subtitle_en,
			subtitleDE: subtitle_de,
			subtitleES: subtitle_es,
			subtitleFR: subtitle_fr,
			subtitleSK: subtitle_sk,
			subtitleCS: subtitle_cs,
			addressPL: address_pl,
			addressEN: address_en,
			addressDE: address_de,
			addressES: address_es,
			addressFR: address_fr,
			addressSK: address_sk,
			addressCS: address_cs,
			urlPL: url_pl,
			urlEN: url_en,
			urlDE: url_de,
			urlES: url_es,
			urlFR: url_fr,
			urlSK: url_sk,
			urlCS: url_cs,
			createdAt: created_at,
			updatedAt: updated_at,
		}
	}

	return { ...fromJSON(json) }
}

export const CMSLocationToJSON = (obj: Partial<ICMSLocationModel>): Partial<ICMSLocation> => {
	const {
		placeId,
		mainCmsLocationId,
		geoPoint,
		isActivePL,
		isActiveEN,
		isActiveDE,
		isActiveES,
		isActiveFR,
		isActiveSK,
		isActiveCS,
		customMenuItem,
		showOnLocations,
		showInMenu,
		showInFooter,
		otherLocation,
		deliveryBus,
		passengerBus,
		phoneNumber,
		namePL,
		nameEN,
		nameDE,
		nameES,
		nameFR,
		nameSK,
		nameCS,
		subtitlePL,
		subtitleEN,
		subtitleDE,
		subtitleES,
		subtitleFR,
		subtitleSK,
		subtitleCS,
		addressPL,
		addressEN,
		addressDE,
		addressES,
		addressFR,
		addressSK,
		addressCS,
		urlPL,
		urlEN,
		urlDE,
		urlES,
		urlFR,
		urlSK,
		urlCS,
		createdAt,
		updatedAt,
		...rest
	} = obj

	return {
		...rest,
		place_id: placeId,
		main_cms_location_id: mainCmsLocationId,
		geo_point: {
			type: 'Point',
			coordinates: [Number(geoPoint?.coordinates[0]), Number(geoPoint?.coordinates[1])],
		},
		is_active_pl: isActivePL,
		is_active_en: isActiveEN,
		is_active_de: isActiveDE,
		is_active_es: isActiveES,
		is_active_fr: isActiveFR,
		is_active_sk: isActiveSK,
		is_active_cs: isActiveCS,
		custom_menu_item: customMenuItem,
		show_on_locations: showOnLocations,
		show_in_menu: showInMenu,
		show_in_footer: showInFooter,
		other_location: otherLocation,
		delivery_bus: deliveryBus,
		passenger_bus: passengerBus,
		phone_number: phoneNumber,
		name_pl: namePL,
		name_en: nameEN,
		name_de: nameDE,
		name_es: nameES,
		name_fr: nameFR,
		name_sk: nameSK,
		name_cs: nameCS,
		subtitle_pl: subtitlePL,
		subtitle_en: subtitleEN,
		subtitle_de: subtitleDE,
		subtitle_es: subtitleES,
		subtitle_fr: subtitleFR,
		subtitle_sk: subtitleSK,
		subtitle_cs: subtitleCS,
		address_pl: addressPL,
		address_en: addressEN,
		address_de: addressDE,
		address_es: addressES,
		address_fr: addressFR,
		address_sk: addressSK,
		address_cs: addressCS,
		url_pl: urlPL,
		url_en: urlEN,
		url_de: urlDE,
		url_es: urlES,
		url_fr: urlFR,
		url_sk: urlSK,
		url_cs: urlCS,
		created_at: createdAt,
		updated_at: updatedAt,
	}
}
